import React, { useState } from 'react';
import { Link } from 'react-router-dom';
export function Footer() {
  const [email, setEmail] = useState('');
  const [firstName, setFirstName] = useState('');
  const handleSubscribe = (e: React.FormEvent) => {
    e.preventDefault();
    console.log('Newsletter signup:', {
      firstName,
      email
    });
    setEmail('');
    setFirstName('');
    alert('Thank you for subscribing!');
  };
  return <footer className="bg-voices-navy text-white" data-id="element-28">
      <div className="max-w-7xl mx-auto px-6 py-12" data-id="element-29">
        <div className="grid md:grid-cols-4 gap-8 mb-8" data-id="element-30">
          {/* Brand */}
          <div className="md:col-span-2" data-id="element-31">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/1FmsnhYgP8wVPnjSwQf5sx/Voices_with_victoria_Ndu2.png" alt="Voices with Victoria" className="h-16 w-auto mb-4" data-id="element-32" />
            <p className="text-gray-300 mb-6" data-id="element-33">
              Faith-forward conversations that challenge, encourage, and equip
              young professionals and creatives.
            </p>
            {/* Newsletter */}
            <form onSubmit={handleSubscribe} className="space-y-3" data-id="element-34">
              <h4 className="font-semibold text-voices-gold" data-id="element-35">
                Subscribe to our newsletter
              </h4>
              <input type="text" placeholder="First Name" value={firstName} onChange={e => setFirstName(e.target.value)} required className="w-full px-4 py-2 rounded-lg text-gray-900" data-id="element-36" />
              <input type="email" placeholder="Email Address" value={email} onChange={e => setEmail(e.target.value)} required className="w-full px-4 py-2 rounded-lg text-gray-900" data-id="element-37" />
              <button type="submit" className="bg-voices-gold text-white px-6 py-2 rounded-lg font-semibold hover:bg-yellow-600 transition-colors" data-id="element-38">
                Subscribe
              </button>
            </form>
          </div>
          {/* Quick Links */}
          <div data-id="element-39">
            <h4 className="font-semibold mb-4 text-voices-gold" data-id="element-40">Quick Links</h4>
            <ul className="space-y-2" data-id="element-41">
              <li data-id="element-42">
                <Link to="/" className="text-gray-300 hover:text-voices-gold" data-id="element-43">
                  Home
                </Link>
              </li>
              <li data-id="element-44">
                <Link to="/event" className="text-gray-300 hover:text-voices-gold" data-id="element-45">
                  Event
                </Link>
              </li>
              <li data-id="element-46">
                <Link to="/podcast" className="text-gray-300 hover:text-voices-gold" data-id="element-47">
                  Podcast
                </Link>
              </li>
              <li data-id="element-48">
                <Link to="/blog" className="text-gray-300 hover:text-voices-gold" data-id="element-49">
                  Blog
                </Link>
              </li>
              <li data-id="element-50">
                <Link to="/about" className="text-gray-300 hover:text-voices-gold" data-id="element-51">
                  About
                </Link>
              </li>
              <li data-id="element-52">
                <Link to="/volunteer" className="text-gray-300 hover:text-voices-gold" data-id="element-53">
                  Volunteer
                </Link>
              </li>
              <li data-id="element-54">
                <Link to="/contact" className="text-gray-300 hover:text-voices-gold" data-id="element-55">
                  Contact
                </Link>
              </li>
            </ul>
          </div>
          {/* Social */}
          <div data-id="element-56">
            <h4 className="font-semibold mb-4 text-voices-gold" data-id="element-57">Follow Us</h4>
            <div className="flex flex-col gap-2" data-id="element-58">
              <a href="https://instagram.com/voiceswithvictoriashow" target="_blank" rel="noopener noreferrer" className="text-gray-300 hover:text-voices-gold" data-id="element-59">
                Instagram
              </a>
              <a href="https://www.linkedin.com/in/victorianwanna/" target="_blank" rel="noopener noreferrer" className="text-gray-300 hover:text-voices-gold" data-id="element-60">
                LinkedIn
              </a>
              <a href="https://youtube.com/@victoriandu" target="_blank" rel="noopener noreferrer" className="text-gray-300 hover:text-voices-gold" data-id="element-61">
                YouTube
              </a>
              <a href="https://web.facebook.com/victoria.nwanna.5" target="_blank" rel="noopener noreferrer" className="text-gray-300 hover:text-voices-gold" data-id="element-62">
                Facebook
              </a>
            </div>
          </div>
        </div>
        {/* Bottom Bar */}
        <div className="border-t border-gray-700 pt-8 flex flex-col md:flex-row justify-between items-center gap-4 text-sm text-gray-400" data-id="element-63">
          <p data-id="element-64">© 2025 Voices with Victoria. All rights reserved.</p>
          <div className="flex gap-6" data-id="element-65">
            <Link to="/terms" className="hover:text-voices-gold" data-id="element-66">
              Terms
            </Link>
            <Link to="/privacy" className="hover:text-voices-gold" data-id="element-67">
              Privacy
            </Link>
            <Link to="/cookies" className="hover:text-voices-gold" data-id="element-68">
              Cookie Policy
            </Link>
          </div>
        </div>
      </div>
    </footer>;
}